'use client'

import { useEffect } from 'react'
import { setUserInCookies } from '@utils/auth'
import { useUserState } from 'src/providers/login-state-management'

type RouteCitySyncProps = {
  cityId?: number | string
  cityName: string
}

export function RouteCitySync({ cityId, cityName }: RouteCitySyncProps) {
  const { addUserDetails, userDetails } = useUserState()

  useEffect(() => {
    if (!cityId) return

    const normalizedCityId = cityId.toString()
    const normalizedCityName = cityName.replace(/-/g, ' ').trim()
    if (
      userDetails?.cityId === normalizedCityId &&
      userDetails.cityName?.toLowerCase() === normalizedCityName.toLowerCase()
    )
      return

    const updatedUser = {
      ...userDetails,
      cityId: normalizedCityId,
      cityName: normalizedCityName,
    }
    addUserDetails(updatedUser)
    void setUserInCookies(updatedUser)
  }, [addUserDetails, cityId, cityName, userDetails])

  return null
}
